import { ThemeColors } from "@hub/values/theme-colors.enum";
import React from "react";
import styles from "./tag.module.css";

interface TagProps {
  themeColor?: ThemeColors;
  tag: string;
}

export const Tag: React.FC<TagProps> = ({
  themeColor = ThemeColors.GREY,
  tag,
}) => {
  return (
    <div className={`${styles.featureTag} ${styles[themeColor]}`}>
      {tag.replace("-", " ")}
    </div>
  );
};
